import React from 'react'
import { StyleProp, ViewStyle } from 'react-native'

import { BottomSheet as BottomSheetWeb } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'

type BottomSheetProps = {
  children?: React.ReactElement
  handleComponent?: React.FC
  visible?: boolean
  onDismiss?: () => void
  snapPoints?:
    | string[]
    | number[]
    | ((minHeight: number, maxHeight: number) => string[] | number[])
  bodyStyle?: StyleProp<ViewStyle>
  disableBottomSheet: () => void
  sheetName?: string
  header?: React.ReactNode
  footer?: React.ReactNode
  eventPayload?: object
}

export const BottomSheet: React.FC<BottomSheetProps> = (props) => {
  const {
    children,
    visible,
    handleComponent,
    onDismiss,
    snapPoints,
    bodyStyle,
    disableBottomSheet,
    sheetName,
    header = null,
    footer = null,
    eventPayload = {},
  } = props

  const animatedSnapPoints = (minHeight: number, maxHeight: number) => {
    if (typeof snapPoints === 'function') {
      return snapPoints?.(minHeight, maxHeight)
    }
    return snapPoints || [minHeight, maxHeight / 2]
  }
  return (
    <BottomSheetWeb
      open={visible}
      onDismiss={onDismiss}
      snapPoints={({ minHeight, maxHeight }) =>
        animatedSnapPoints(minHeight, maxHeight)
      }
      header={header}
      footer={footer}
    >
      <>{children}</>
    </BottomSheetWeb>
  )
}
